/**
 * Loader — molecule-level async feedback block.
 */
import React from "react";
import { Spinner, Typography } from "@/components/ui/atoms";
import { cn } from "@/utils/cn";
import type { LoaderProps } from "./Loader.types";

export const Loader: React.FC<LoaderProps> = ({
  title = "Loading",
  message = "Please wait while we prepare the content.",
  className,
  compact = false,
  spinnerVariant = "gradient-ring",
}) => {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center text-center",
        compact ? "min-h-56" : "min-h-72",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Spinner
        size="lg"
        variant={spinnerVariant}
        intent="primary"
        aria-label="Loading in progress"
      />
      <Typography variant="h4" color="primary" className="mt-4">
        {title}
      </Typography>
      <Typography as="p" variant="body-sm" color="muted" className="mt-1 max-w-md">
        {message}
      </Typography>
    </div>
  );
};

